import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/miraimon.jpg'


const _hoisted_1 = { style: {"background-color":"rgb(32,33,35)","width":"100%","cursor":"pointer"} }
const _hoisted_2 = {
  id: "loadingview",
  style: {"width":"100%","height":"100%","cursor":"auto","display":"inline-block","position":"absolute","z-index":"99999","left":"0","background-color":"rgba(0,0,0,0.3)"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"spinner-box-w\"><div class=\"pulse-container-w\"><div class=\"pulse-bubble-w pulse-bubble-1-w\"></div><div class=\"pulse-bubble-w pulse-bubble-2-w\"></div><div class=\"pulse-bubble-w pulse-bubble-3-w\"></div></div></div>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "col-12",
  style: {"padding":"2%"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "あなた", -1)
const _hoisted_7 = {
  key: 1,
  class: "col-12",
  style: {"padding":"2%","background-color":"#444654"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"32px"},
    src: _imports_0
  })
], -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  class: "col-12",
  style: {"position":"absolute","left":"0","bottom":"0"}
}
const _hoisted_11 = { style: {"width":"10%","display":"inline-block"} }
const _hoisted_12 = { style: {"cursor":"pointer","display":"inline-block","vertical-align":"60%"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([_ctx.windowCss, {"right":"3%","background-color":"rgb(86,88,105)","color":"snow","position":"fixed","bottom":"0%","z-index":"99999999"}]),
    class: _normalizeClass(_ctx.showChat + _ctx.windowClass)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        style: {"color":"green","font-size":"22px","position":"absolute","left":"2px","line-height":"22px"},
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expansionWindow && _ctx.expansionWindow(...args)))
      }, " ● "),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openChat && _ctx.openChat(...args)))
      }, " PaletteIoT AI Chat "),
      _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [
        [_vShow, !_ctx.isLoaded]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.show),
      style: _normalizeStyle(_ctx.messagesCss)
    }, [
      _createElementVNode("div", {
        class: "col-12 scroll_bar",
        style: _normalizeStyle([{"text-align":"left","overflow":"auto"}, _ctx.messagesScrollCss]),
        ref: "comments"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: message }, [
            (message.role==='user')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" : "),
                  _createElementVNode("span", null, _toDisplayString(message.content), 1)
                ]))
              : _createCommentVNode("", true),
            (message.role==='assistant')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" : "),
                  _createElementVNode("span", {
                    innerHTML: message.content
                  }, null, 8, _hoisted_9)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 4),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("textarea", {
          onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.keyEnterShift && _ctx.keyEnterShift(...args)), ["shift"]), ["enter"])),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userMessage.content) = $event)),
          class: "form-control col-8",
          style: {"max-width":"83%","color":"snow","row":"1","border":"none","resize":"none","outline":"none","font-size":"15px","background":"rgba(217, 217, 227, 0.1)","margin":"1%","display":"inline-block"}
        }, null, 544), [
          [_vModelText, _ctx.userMessage.content]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.faPaperPlane,
              size: "md",
              onClick: _ctx.chat
            }, null, 8, ["icon", "onClick"])
          ]),
          _createTextVNode(),
          _hoisted_13,
          _createElementVNode("div", {
            style: _normalizeStyle([_ctx.voiceInputCss, {"cursor":"pointer","display":"inline-block","vertical-align":"40%"}])
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.faMicrophone,
              size: "md",
              onClick: _ctx.voiceInput
            }, null, 8, ["icon", "onClick"])
          ], 4)
        ])
      ])
    ], 6),
    _hoisted_14
  ], 6)), [
    [_vShow, 'hide'!==_ctx.showChat ]
  ])
}